<template>
  <div class="voting__wrapper">
    <awards-top-section class="voting__top-section">
      <template slot="title">{{ votingTitle }}</template>
      <awards-top-section-voting-button slot="button" />
    </awards-top-section>

    <awards-about-section />

    <voting-process-section />

    <voting-key-dates-section />

    <voting-vote-section
      :categories-response="categoriesResponse.Categories"
      :was-authorized-data-received="wasAuthorizedDataReceived"
      :in-progress="inProgress"
      :was-error-on-categories-request="wasErrorOnCategoriesRequest"
    />

    <homepage-judges-section />
  </div>
</template>

<script>
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'
import { PROJECT_PHASE } from 'enums/project-phase'
import mixins from '@/utils/mixins'
import { VOTING_STATUS } from 'sections/_voting/VotingVoteSection/VotingVoteForm/enums'
import { mapActions, mapGetters } from 'vuex'
import AwardsTopSection from 'sections/_shared/AwardsTopSection'
import AwardsTopSectionVotingButton from 'sections/_shared/AwardsTopSection/AwardsTopSectionVotingButton/index.vue'
import { IS_VOTING_CLOSED } from 'enums/main-route'
import { ROUTE_NAME } from 'enums/routes'
import VotingVoteSection from 'sections/_voting/VotingVoteSection'

export default {
  name: 'VotingPage',
  mixins: [mixins.initialScroll],
  components: {
    AwardsTopSectionVotingButton,
    AwardsTopSection,
    VotingVoteSection,
    AwardsAboutSection: hydrateWhenVisible(() =>
      import('sections/_shared/AwardsAboutSection')
    ),
    VotingKeyDatesSection: hydrateWhenVisible(() =>
      import('sections/_voting/VotingKeyDatesSection')
    ),
    HomepageJudgesSection: hydrateWhenVisible(() =>
      import('sections/_homepage/HomepageJudgesSection')
    ),
    VotingProcessSection: hydrateWhenVisible(() =>
      import('sections/_voting/VotingProcessSection')
    )
  },
  head() {
    return this.$generateMetaTags()
  },
  consts: {
    PROJECT_PHASE
  },
  async asyncData(ctx) {
    if (IS_VOTING_CLOSED) {
      return []
    }
    try {
      const categoriesResponse = await ctx.store.dispatch(
        'categories/requestCategories'
      )
      return {
        inProgress: false,
        wasErrorOnCategoriesRequest: false,
        wasAuthorizedDataReceived: false,
        categoriesResponse: categoriesResponse
      }
    } catch (err) {
      ctx.$errorHandler(err, this)
      return {
        inProgress: false,
        wasAuthorizedDataReceived: false,
        wasErrorOnCategoriesRequest: true,
        categoriesResponse: {}
      }
    }
  },
  data() {
    return {
      categoriesResponse: {
        Categories: {},
        VotingStatus: null
      },
      wasAuthorizedDataReceived: false,
      inProgress: false,
      wasErrorOnCategoriesRequest: false
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn'
    }),
    votingTitle() {
      return IS_VOTING_CLOSED ? 'Voting is now closed' : 'Voting is now open'
    }
  },
  watch: {
    isLoggedIn() {
      this.getCategories()
    }
  },
  methods: {
    ...mapActions({
      requestCategories: 'categories/requestCategories'
    }),
    async getCategories() {
      try {
        this.inProgress = true
        this.wasAuthorizedDataReceived = false
        const categoriesResponse = await this.requestCategories()
        this.categoriesResponse = categoriesResponse

        if (this.isLoggedIn) {
          this.wasAuthorizedDataReceived = true
        }

        this.wasErrorOnCategoriesRequest = false
        this.checkVotingStatus()
      } catch (err) {
        this.$errorHandler(err, this)
        this.wasErrorOnCategoriesRequest = true
      } finally {
        this.inProgress = false
      }
    },
    checkVotingStatus() {
      if (this.categoriesResponse.VotingStatus === VOTING_STATUS.SUBMITTED) {
        this.$router.push({
          name: ROUTE_NAME.THANK_YOU
        })
      }
    }
  },
  mounted() {
    this.getCategories()
  }
}
</script>
